import { z } from 'zod';

import { storeCodeSchema } from 'schema/storeCode';

export const accessTokenPayloadSchema = z.object({
  id: z.number(),
  exp: z.number(),
  store: storeCodeSchema,
  shopify: z
    .object({
      accessToken: z.string(),
      expiresAt: z.number()
    })
    .optional()
});

export const sessionCustomerSchema = z.object({
  id: z.number(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  phone: z.string().nullable(),
  tags: z.string().array().nullable().optional(),
  metafields: z
    .array(
      z.object({
        key: z.string(),
        value: z.union([z.string(), z.number(), z.boolean(), z.null()])
      })
    )
    .nullable()
    .optional()
});

export const sessionSchema = z.object({
  accessToken: z.string(),
  accessTokenPayload: accessTokenPayloadSchema,
  customer: sessionCustomerSchema
});

export type Session = z.infer<typeof sessionSchema>;
export type SessionCustomer = z.infer<typeof sessionCustomerSchema>;
